import { z } from 'zod';
import { TaggedDataSetReference } from 'libs/end-to-end/src/types/databases/data-sets/data-set-reference';
import { TopLevelAnalysisRequest } from 'libs/end-to-end/src/custom-viz/TopLevelAnalysisTypes';

export const DataSchedulingPlannedPull = z.object({
  organizationId: z.string(),
  databaseId: z.string(),
  datasetId: z.string(),
  automationTagForDataset: z.string(),
  newDatasetVersion: z.string(),
});

export type DataSchedulingPlannedPull = z.infer<
  typeof DataSchedulingPlannedPull
>;

export const DataSchedulingSetupState = z.object({
  organizationId: z.string(),
  databaseId: z.string(),
  databaseRevisionId: z.string().nullable(),
  oldTransformId: z.string().nullable(),
  target: z
    .union([
      z.object({
        type: z.literal('dataset'),
        dataSetId: z.string(),
      }),
      z.object({
        type: z.literal('transform'),
        oldTransformId: z.string(),
        databaseRevisionId: z.string(),
      }),
    ])
    .default({
      type: 'transform',
      oldTransformId: '',
      databaseRevisionId: '',
    }),
  dataSetReferences: z.array(TaggedDataSetReference),
});

export type DataSchedulingSetupState = z.infer<typeof DataSchedulingSetupState>;

export const DataSchedulingPlannedPullsState = z.object({
  iterations: z.array(DataSchedulingPlannedPull),
  skippedDatasetReferences: z.array(TaggedDataSetReference),
});

export type DataSchedulingPlannedPullsResult = z.infer<
  typeof DataSchedulingPlannedPullsState
>;

export const DatabaseSchedulingProduceDagState = z.object({
  startingIndex: z.number(),
});

export type DatabaseSchedulingProduceDagState = z.infer<
  typeof DatabaseSchedulingProduceDagState
>;

export const DataSchedulingRunTransformState = z.object({
  transformId: z.string(),
});

export type DataSchedulingRunTransformState = z.infer<
  typeof DataSchedulingRunTransformState
>;

export const DataSchedulingPrepareNewRevisionState = z.object({
  organizationId: z.string(),
  databaseId: z.string(),
  newRevisionId: z.string(),
});

export type DataSchedulingPrepareNewRevisionState = z.infer<
  typeof DataSchedulingPrepareNewRevisionState
>;

export const DataSchedulingValidateNewRevisionState = z.object({
  customVizRequest: TopLevelAnalysisRequest,
});

export type DataSchedulingValidateNewRevisionState = z.infer<
  typeof DataSchedulingValidateNewRevisionState
>;

export const DataSchedulingValidateTopLevelAnalysisState = z.object({
  organizationId: z.string(),
  databaseId: z.string(),
  databaseRevisionId: z.string(),
});

export type DataSchedulingValidateTopLevelAnalysisState = z.infer<
  typeof DataSchedulingValidateTopLevelAnalysisState
>;
